import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { ApiService } from '../core/upgraded-providers';

import { ShardsDataSource } from './shards.data-source';

@Injectable()
export class ShardsResolver implements Resolve<any> {
  constructor(
    private _apiService: ApiService
  ) {
    // Noop.
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
    const dataSource = new ShardsDataSource(this._apiService);

    return dataSource.getData().toPromise();
  }
}
